import classnames from 'classnames/bind';
import { PropsWithChildren } from 'react';
import styles from './index.module.scss';

const BLOCK_NAME = 'Help-Center-Content';
const cn = classnames.bind(styles);

type TProps = PropsWithChildren<{
  isSideMode: boolean;
}>;

export const HelpCenterContent = ({ children, isSideMode }: TProps) => {
  return (
    <div
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--is-side-mode`]: isSideMode,
      })}
    >
      {children}
    </div>
  );
};
